import clsx from 'clsx'
import type React from 'react'

import type { TagProps } from '@/types/components/tag'

import styles from './Tag.module.scss'

type Props = React.PropsWithChildren<TagProps>

export const Tag: React.FC<Props> = ({ theme, text, type, children }) => {
  const classes = [
    styles.tag,
    theme &&
      (type === 'default' || type === 'compact') &&
      styles[`tag--${theme}`],
    styles[`tag--${type}`],
    'type-label',
    `theme-${theme ? theme : 'melon-light'}`,
  ]

  return (
    <span
      className={clsx(classes)}
      style={theme === 'white' ? { color: 'black' } : {}}
    >
      {text}
      {children}
    </span>
  )
}
